import request from '@/utils/request'

// 查询 AI 盒子告警类型映射列表
export function listAlarmTypeMappings(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/appDirect/aiBoxAlarmTypeMapping/listAiBoxAlarmTypeMappings',
      method: 'post',
      data: params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        // 兼容两种返回结构：mappings/total 在顶层，或嵌套在 data 里
        const source = (res.data && (res.data.mappings || res.data.total !== undefined)) ? res.data : res
        resolve({
          total: Number(source.total || 0),
          list: source.mappings || []
        })
      } else {
        reject(new Error(res.msg || res.message || '获取告警类型映射列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 新增告警类型映射
export function saveAlarmTypeMapping(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/app/aiBoxAlarmTypeMapping.saveAiBoxAlarmTypeMapping',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || res.message || '新增告警类型映射失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改告警类型映射
export function updateAlarmTypeMapping(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/app/aiBoxAlarmTypeMapping.updateAiBoxAlarmTypeMapping',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || res.message || '修改告警类型映射失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除告警类型映射（逻辑删除）
export function deleteAlarmTypeMapping(mappingId) {
  return new Promise((resolve, reject) => {
    request({
      url: '/app/aiBoxAlarmTypeMapping.deleteAiBoxAlarmTypeMapping',
      method: 'post',
      data: { mappingId }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || res.message || '删除告警类型映射失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
